import { useState } from 'react';
import { IStopArea } from '../../../../../models/stop-area.model';
import { t } from '../../../../../services/texts.service';
import Fact from '../../../../Shared/Fact';
import { IconMotif } from '../../../../Shared/Icon/icon-motif.enum';

export default function StopAreasFact({ stopAreas }: { stopAreas: IStopArea[] }) {
  const numberOfStopAreasToShowInitially = 3;
  const [isExpanded, setIsExpanded] = useState(false);

  if (stopAreas.length === 0) {
    return null;
  }

  const visibleCount = isExpanded ? stopAreas.length : Math.min(numberOfStopAreasToShowInitially, stopAreas.length);
  const liveRegionText = isExpanded
    ? t(`Visar alla ${stopAreas.length} hållplatser`, `Showing all ${stopAreas.length} stop areas`)
    : t(`Visar ${visibleCount} av ${stopAreas.length} hållplatser`, `Showing ${visibleCount} of ${stopAreas.length} stop areas`);

  return (
    <Fact iconMotif={IconMotif.PersonAtStop} altText="">
      <div>
        <div id="affected-stop-areas-list-label" className="fw-bold">
          {t('Påverkade hållplatser', 'Affected stop areas')}
        </div>
        {stopAreas.length > numberOfStopAreasToShowInitially && (
          <div className="visually-hidden" aria-live="polite" aria-atomic="true">
            {liveRegionText}
          </div>
        )}
        <ul id="affected-stop-areas-list" className="ps-2 mb-0" aria-labelledby="affected-stop-areas-list-label">
          {stopAreas
            .filter((_, index) => isExpanded || index < numberOfStopAreasToShowInitially)
            .map((stopArea) => (
              <li key={stopArea.gid}>{stopArea.name}</li>
            ))}
        </ul>
        {stopAreas.length > numberOfStopAreasToShowInitially && (
          <button
            type="button"
            className={`btn btn-tertiary btn-icon-right btn-icon-caret-down btn-tertiary-icon-rotatable ${isExpanded ? '' : 'collapsed'}`}
            onClick={() => setIsExpanded(!isExpanded)}
            aria-expanded={isExpanded}
            aria-controls="affected-stop-areas-list"
          >
            {isExpanded ? t('Visa färre hållplatser', 'Show less stop areas') : t('Visa alla hållplatser', 'Show all stop areas')}
          </button>
        )}
      </div>
    </Fact>
  );
}
